export default __webpack_public_path__ + "static/media/juego1_ganar.41f56b76.png";